"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Registration = /** @class */ (function () {
    function Registration() {
        this.default();
    }
    Registration.prototype.default = function () {
        return {
            first_name: null,
            last_name: null,
            company: null,
            policy: null,
            email: null,
            phone: null,
            address: null,
            country: null,
            city: null,
            state: null,
            zip: null,
            agreement: null,
            send_digest: 0,
        };
    };
    return Registration;
}());
exports.default = Registration;
